import type { ComponentProps } from 'react';

import { cn } from '@crm/shared/lib/styles/utils';

type EditableTextareaProps = Omit<ComponentProps<'textarea'>, 'defaultValue' | 'value'> & {
    value: string | number | null;
};

export const EditableTextarea = ({
    value,
    className,
    onFocus,
    onMouseLeave,
    ...props
}: EditableTextareaProps) => (
    <textarea
        defaultValue={value ?? ''}
        placeholder="-"
        className={cn(
            'field-sizing-content h-27 max-h-27 w-full min-w-0 resize-none overflow-y-auto rounded-lg border border-transparent px-2 py-1.5 text-xs leading-4 font-normal text-smtr-main-black-100 transition-colors outline-none',
            'border-gray-200 placeholder:text-smtr-main-tertiary-100 hover:bg-white focus:border-gray-200 focus:bg-white focus:shadow-sm aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[suppress-hover=true]:hover:border-transparent',
            className
        )}
        onFocus={(event) => {
            delete event.currentTarget.dataset.suppressHover;
            onFocus?.(event);
        }}
        onMouseLeave={(event) => {
            delete event.currentTarget.dataset.suppressHover;
            onMouseLeave?.(event);
        }}
        {...props}
    />
);
